import { render, staticRenderFns } from "./DisplayKindKB.vue?vue&type=template&id=222c57f4&scoped=true&"
import script from "./DisplayKindKB.vue?vue&type=script&lang=js&"
export * from "./DisplayKindKB.vue?vue&type=script&lang=js&"
import style0 from "./DisplayKindKB.vue?vue&type=style&index=0&id=222c57f4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c57f4",
  null
  
)

export default component.exports